import { Button, InputField, InputLabel, InputWrapper } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { Form, Formik } from 'formik';
import type { FC } from 'react';
import { FaFacebookF } from 'react-icons/fa';
import googleIcon from './assets/google-icon.svg';
import * as Styled from './styled';
import type { LoginFormProps, LoginFormValues } from './types';

export * from './types';

export const LoginForm: FC<LoginFormProps> = (props) => {
  const {
    form,
    onFacebookClick,
    onGoogleClick,
    onForgotPasswordClick,
    joinLink,
    loading = false,
  } = props;
  const { translate } = useTranslation();

  return (
    <>
      <Formik<LoginFormValues> {...form} enableReinitialize>
        {() => (
          <Form>
            <InputWrapper>
              <InputLabel>{translate('common.inputs.email.label')}</InputLabel>
              <InputField disabled={loading} name="email" type="email" />
            </InputWrapper>
            <InputWrapper>
              <InputLabel>{translate('common.inputs.password.label')}</InputLabel>
              <InputField disabled={loading} name="password" type="password" />
              <Styled.ForgotPasswordLink onClick={onForgotPasswordClick}>
                {translate('common.buttons.forgotPassword')}
              </Styled.ForgotPasswordLink>
            </InputWrapper>

            <InputWrapper>
              <Button color="blue" loading={loading} type="submit">
                {translate('common.buttons.loggingin')}
              </Button>
            </InputWrapper>

            {!!joinLink && (
              <Styled.RegisterWrapper>
                <span>{translate('glossary.noAccount')}</span>
                <Styled.RegisterLink to={joinLink}>
                  {translate('common.buttons.register')}
                </Styled.RegisterLink>
              </Styled.RegisterWrapper>
            )}
            <Styled.Separator />
            <InputWrapper>
              <Button color="white" outlined onClick={onGoogleClick} disabled={loading}>
                <Styled.SsoButtonIconWrapper>
                  <img src={googleIcon} alt="" />
                </Styled.SsoButtonIconWrapper>
                {translate('common.buttons.googleLogin')}
              </Button>
            </InputWrapper>
            <InputWrapper>
              <Styled.SsoButtonFacebook color="blue" onClick={onFacebookClick} disabled={loading}>
                <Styled.SsoButtonIconWrapper>
                  <FaFacebookF />
                </Styled.SsoButtonIconWrapper>
                {translate('common.buttons.facebookLogin')}
              </Styled.SsoButtonFacebook>
            </InputWrapper>
          </Form>
        )}
      </Formik>
    </>
  );
};
